import cloneDeep from 'lodash/cloneDeep';
import createQuestion from '@/components/Editor/Form/Questions/AddMenu/createQuestion';
const PREFIX = 'common: utils: widget: update: addGenericSectionFor:';
export const DEFAULT_CONFIGS = {
  Form: {
    displayName: 'Form',
    questions: [createQuestion('input', 1)],
    // Add single generic question
    groups: []
  },
  StackedBars: {
    displayName: 'Comparison Bars',
    seriesOptions: []
  },
  List: {
    displayName: 'List',
    seriesOptions: [],
    tooltip: '',
    tabs: [],
    ctaButton: '',
    ctaPrompt: ''
  },
  Overview: {
    displayName: 'Overview',
    seriesOptions: []
  },
  Table: {
    displayName: 'Table',
    seriesOptions: [],
    selectionsLabeled: false
  },
  TreeMap: {
    displayName: 'Tree Map',
    tooltip: '',
    seriesOptions: []
  },
  StackedBarChart: {
    displayName: 'Stacked Column Chart',
    seriesOptions: [],
    selectionsStrategy: 'stacked',
    selectionsLabeled: false
  },
  ColumnChart: {
    displayName: 'Column Chart',
    seriesOptions: []
  },
  BarChart: {
    displayName: 'Bar Chart',
    chartType: 'horizontal',
    seriesOptions: [],
    selectionsStrategy: 'groups',
    selectionsLabeled: false
  },
  LineChart: {
    displayName: 'Line Chart',
    seriesOptions: [],
    selectionsStrategy: 'multiLine',
    selectionsLabeled: false
  },
  AreaChart: {
    displayName: 'Area Chart',
    seriesOptions: [],
    chartStyle: 'area'
  },
  StackedAreaChart: {
    displayName: 'Stacked Area Chart',
    seriesOptions: [],
    chartStyle: 'stackedArea',
    selectionsStrategy: 'multiLine'
  },
  Receipt: {
    displayName: 'Receipt',
    seriesOptions: [],
    selectionsLabeled: false
  },
  PieDoughnut: {
    displayName: 'Pie',
    seriesOptions: [],
    collectionOptions: [],
    chartType: 'pie',
    selectionsStrategy: 'rings',
    selectionsLabeled: false
  },
  Doughnut: {
    displayName: 'Donut',
    seriesOptions: [],
    collectionOptions: [],
    chartType: 'doughnut'
  },
  Bubble: {
    displayName: 'Bubble Chart',
    seriesOptions: [],
    collectionOptions: [],
    selectionsStrategy: 'categories',
    selectionsLabeled: false
  },
  Scatter: {
    displayName: 'Scatter Plot',
    seriesOptions: [],
    collectionOptions: [],
    selectionsStrategy: 'categories',
    selectionsLabeled: false
  },
  GaugeChart: {
    displayName: 'Gauge Chart',
    seriesOptions: []
  },
  RadarChart: {
    displayName: 'Radar Chart',
    seriesOptions: [],
    selectionsLabeled: false
  }
}; // Convert alternative component names
// to their actual component names, used
// by layout system

const systemComponentNameMap = {
  AreaChart: 'LineChart',
  StackedAreaChart: 'LineChart',
  Doughnut: 'PieDoughnut',
  ColumnChart: 'BarChart'
};
export default function addGenericSectionFor(component) {
  let layoutGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const config = cloneDeep(DEFAULT_CONFIGS[component]);

  if (!config) {
    throw Error(`${PREFIX} section: "${component}" is not supported`);
  } // Set default selection strategy, if necessary


  if (!config.selectionsStrategy) {
    config.selectionsStrategy = 'default';
  } // Add to optional layout group


  if (layoutGroup) config.layoutGroup = layoutGroup;
  const componentName = systemComponentNameMap[component] ?? component;
  return {
    config,
    component: componentName
  };
}